// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","FilterLinks__link":"ce_a bii_h bii_kh bii_we bii_su bii_vt bii_sw bii_sn"};